const idtp = [
  {value: 1, label: 'NIT'},
  {value: 2, label: 'Cédula Ciudadania'},
  {value: 3, label: 'Cédula Extrangeria'},
]

const banks = [
  {value: 1, label: 'Bancolombia'}
];


function today() {
  const now = new Date();
  const month = ((now.getMonth()+1) < 10) ? `0${now.getMonth()}` : now.getMonth();
  const day = (now.getDate() < 10) ? `0${now.getDate()}` : now.getDate();
  return `${now.getFullYear()}-${month}-${day}`
}

export const SUPPORT_OPTIONS = [
  {
    ndx: 1,
    icon: '/assets/svg/support/option-04.svg',
    name: 'Acerca de mi pedido',
    desc: 'Escríbenos tu problema y cuéntanos qué quieres que hagamos para poder ayudarte.',
    widgets: [
      {
        wtype: 'list',
        title: 'Tipo de incidente',
        multiple: false,
        options: [
          {
            id: 1,
            cat: 'donde_esta',
            uid: 'donde_esta',
            desc: '¿Donde está mi pedido?',
            ticketOn: false,
            chatOn: true
          },
          {
            id: 2,
            cat: 'demora_en_llegar',
            uid: 'demora_en_llegar',
            desc: 'Mi pedido se demora en llegar',
            ticketOn: false,
            chatOn: true
          },
          {
            id: 3,
            cat: 'pedido_no_entregado',
            uid: 'pedido_no_entregado',
            desc: 'Mi pedido no fué entregado',
            ticketOn: false,
            chatOn: true
          }
        ],
        checked: null,
      },
    ],
    asistencia: 360064947072,
    callback: 'doubleCobro',
  },
  {
    ndx: 2,
    icon: '/assets/svg/support/option-03.svg',
    name: 'Inconveniente con mís productos',
    file: null,
    uid: 'producto_llegó_en_mal_estado',
    desc: 'Selecciona el producto que llegó en mal estado y escríbenos para poder ayudarte.',
    widgets: [
      {
        wtype: 'list',
        title: 'Tipo de incidente',
        options: [
          {
            id: 1,
            cat: 'inconveniente_producto',
            uid: 'pedido_incompleto',
            desc: 'Mi pedido llego incompleto',
          },
          {
            id: 2,
            cat: 'donde_esta',
            uid: 'producto_llegó_en_mal_estado',
            desc: 'Producto llegó en mal estado',
          },
          {
            id: 3,
            cat: 'inconveniente_producto',
            uid: 'otro_producto',
            desc: 'Llegó otro producto',
          },
        ]
      },
      {
        wtype: 'products-list',
        products: [],
        values: null,
      },
      {
        wtype: 'textblock',
        title: 'Escríbenos tus comentarios:',
      },
      {
        wtype: 'image-unload',
        title: 'Adjuntar imagen del producto:',
        source: '',
      },
    ],
    callback: 'malEstado',
  },
  {
    ndx: 3,
    icon: '/assets/svg/support/option-01.svg',
    name: 'Dudas con el cobro',
    desc: 'Si tienes alguna duda escríbenos para poder ayudarte',
    invoice: {src: '/assets/svg/support/invoice.jpg'},
    widgets: [
      {
        wtype: 'list',
        title: 'Tipo de incidente',
        multiple: false,
        options: [
          {
            id: 1,
            cat: 'dudas_con_el_cobro_doble_cobro',
            uid: 'cobro_errado',
            desc: 'Me cobraron un monto diferente',
            ticketOn: true,
            chatOn: false
          },
          {
            id: 2,
            cat: 'dudas_con_el_cobro_doble_cobro',
            uid: 'doble_cobro_',
            desc: 'Doble Cobro',
            ticketOn: true,
            chatOn: false
          },
          {
            id: 3,
            cat: 'dudas_con_el_cobro_doble_cobro',
            uid: 'cobrado_en_línea_y_no_entregado',
            desc: 'Cobrado en línea y no entregado',
            ticketOn: true,
            chatOn: false
          },
          {
            id: 4,
            cat: 'dudas_con_el_cobro_doble_cobro',
            uid: 'no_recibí_un_producto_y_me_cobraron',
            desc: 'No recibí un producto y me cobraron',
            ticketOn: true,
            chatOn: false
          },
          {
            id: 5,
            cat: 'dudas_con_el_cobro_doble_cobro',
            uid: 'error_en_facturación',
            desc: 'No se aplicó promoción o cupón',
            ticketOn: true,
            chatOn: false
          }
        ],
        checked: null,
      },
      {
        wtype: 'list-bank',
        title: 'Payout',
        options: [
          {
            id: 1,
            cat: 'payout',
            uid: 'acount-bank',
            desc: 'Cuenta de ahorros',
            optionType: 'bank',
          },
          {
            id: 2,
            cat: 'payout',
            uid: 'acount-bank',
            desc: 'Cuenta corriente',
            optionType: 'bank',
          },
          {
            id: 3,
            cat: 'payout',
            uid: 'nequi',
            desc: 'Nequi',
            optionType: 'bank',
          },
          {
            id: 4,
            cat: 'payout',
            uid: 'daviplata',
            desc: 'Daviplata',
            optionType: 'bank',
          },
        ],
        checked: {id: 1},          
        fields: [
          {tp: 1, value: null, name: 'fullname',      label: 'Nombre completo'},
          {tp: 5, value: idtp[1],    name: 'document',      label: 'Tipo documento', options: idtp},
          {tp: 2, value: null, name: 'documentNumber',label: 'Número documento'},
          {tp: 4, value: today(), name: 'documentDate',  label: 'Fecha de expedición'},
          {tp: 4, value: today(), name: 'birthday',      label: 'Fecha de nacimiento'},
          {tp: 3, value: null, name: 'email',         label: 'Correo electrónico', errorText: 'Verifique la dirección de correo.'},
          {tp: 5, value: 0,    name: 'bankname',      label: 'Banco', options: banks, onlyform: [1,2]},
          {tp: 2, value: null, name: 'acountNumber',  label: 'Número de cuenta', onlyform: [1,2]},
          {tp: 2, value: null, name: 'phonenumber',   label: 'Número de telefóno', onlyform: [3,4]},
          {tp: 7, value: 0, name:'amount', checked: 1,label: 'Selecciona el monto'},
        ]
      },
      {
        wtype: 'textfield',
        name: 'cupon',
        value: '',
        itemlink: 5,
        title: 'Código del cupón:',
        placeholder: 'Escribe aquí el código',
      },
      {
        wtype: 'textblock',
        title: 'Escríbenos tus comentarios:',
        comment: '',
      },
    ],
    asistencia: 360064947072,
    callback: 'doubleCobro',
  },
  {
    ndx: 5,
    icon: '/assets/svg/support/option-02.svg',
    name: 'Incidente con el mensajero',
    desc: 'Nuestro personal ya está al tanto de lo sucedido.<br>A continuación te'
    + ' damos la información de tu caso para que le puedas hacer seguimiento.',
    widgets: [
      {
        wtype: 'list',
        options: [
          {
            id: 1,
            cat: 'incidente_con_el_mensajero',
            uid: 'mala_actitud',
            desc: 'Mala actitud',
          },
          {
            id: 2,
            cat: 'incidente_con_el_mensajero',
            uid: 'mala_presentación',
            desc: 'Mala presentación',
          },
          {
            id: 3,
            cat: 'incidente_con_el_mensajero',
            uid: 'problemas_con_el_datáfono',
            desc: 'Problemas con el datáfono',
          }          
        ],
        values: null,
      },
      {
        wtype: 'textblock',
        title: 'Escríbenos tus comentarios:',
      },
    ],
    messenger: true,
    callback: 'incidenteMensajero',
  },
  {
    ndx: 6,
    icon: '/assets/svg/support/option-01.svg',
    name: 'Mi factura',
    desc: 'Escríbenos tu problema y cuéntanos qué quieres que hagamos para poder ayudarte.',
    file: null,
    invoice: {src: '/assets/svg/support/invoice.jpg'},
    uid: 'mi_factura',
    widgets: [
      {
        wtype: 'list',
        title: 'Tipo de incidente',
        options: [
          {
            id: 1,
            cat: 'mi_factura',
            uid: 'copia_de_factura_pos',
            desc: 'Copia de factura pos',
            ticketOn: true,
          },
          {
            id: 2,
            cat: 'mi_factura',
            uid: 'historial_de_facturas',
            desc: 'Historial de facturas',
            ticketOn: true,
          },
          {
            id: 3,
            cat: 'mi_factura',
            uid: 'factura_electronica',
            desc: 'Factura electrónica',
            ticketOn: true,
          },
        ],
        checked: null,
      },{
        wtype: 'custom-invoice',
        title: 'Escríbenos tus comentarios:',
        fields: {
          name: null,
          nit: null,
          address: null,
          city: null,
          email: null,
          mobile: null
        },
        itemlink: 3
      },
      {
        wtype: 'textblock',
        title: 'Escríbenos tus comentarios:',
        comment: '',
      },
    ],
    chatOn: true,
    callback: 'miFactura'
  }
];